// Display helpers.

const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
const usd0 = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });

export function money(n: number | string | null | undefined, cents = true): string {
  if (n === null || n === undefined || n === '') return '—';
  return (cents ? usd : usd0).format(Number(n));
}

/** 'YYYY-MM-DD' -> 'Mar 1, 2027' without time-zone drift. */
export function date(d: string | null | undefined): string {
  if (!d) return '—';
  const [y, m, day] = d.slice(0, 10).split('-').map(Number);
  return new Date(Date.UTC(y!, m! - 1, day!)).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
}

export function dateTime(ts: string | null | undefined): string {
  if (!ts) return '—';
  return new Date(ts).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
}

export function relative(ts: string | null | undefined): string {
  if (!ts) return 'never';
  const days = Math.floor((Date.now() - new Date(ts).getTime()) / 86_400_000);
  if (days <= 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 30) return `${days} days ago`;
  if (days < 365) return `${Math.floor(days / 30)} mo ago`;
  return `${Math.floor(days / 365)} yr ago`;
}

/** "+14045550101" -> "(404) 555-0101" */
export function phone(e164: string | null | undefined, ext?: string | null): string {
  if (!e164) return '—';
  const m = e164.match(/^\+1(\d{3})(\d{3})(\d{4})$/);
  const base = m ? `(${m[1]}) ${m[2]}-${m[3]}` : e164;
  return ext ? `${base} x${ext}` : base;
}

export function personName(c: { display_name?: string | null; first_name?: string | null; last_name?: string | null }): string {
  const joined = [c.first_name, c.last_name].filter(Boolean).join(' ');
  return joined || c.display_name || '(no name)';
}

export function todayISO(): string {
  return new Date().toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
}

export function addDaysISO(days: number, from = todayISO()): string {
  const [y, m, d] = from.split('-').map(Number);
  const x = new Date(Date.UTC(y!, m! - 1, d! + days));
  return x.toISOString().slice(0, 10);
}

export const ORG_TYPE_LABEL: Record<string, string> = {
  practice_tenant: 'Practice / tenant',
  landlord_owner: 'Landlord / owner',
  brokerage: 'Brokerage',
  lender: 'Lender',
  health_system: 'Health system',
  other: 'Other',
};

export const PROPERTY_TYPE_LABEL: Record<string, string> = { mob: 'MOB', office: 'Office', retail: 'Retail', land: 'Land', other: 'Other' };

export const CONTACT_TYPES = ['tenant', 'landlord', 'broker', 'lender', 'investor', 'vendor', 'other'] as const;
